export const PUBLIC_PATHS = {
  home: '/',
  pricing: '/pricing',
  terms: '/terms',
  privacy: '/privacy',
  about: '/about',
  paul: '/paul-lin',
  blog: '/blog',
  blogPost: '/blog/:slug',
  humanAiProject: '/human-ai-project',
  research: '/research',
  careers: '/careers',
  howWeProtect: '/how-we-protect-your-voice',
  keepVoiceForever: '/keep-this-voice-forever',
  waitlist: '/waitlist',
  deprecatedClaim: '/c/:token',
} as const

export const AUTH_PATHS = {
  login: '/login',
  verify: '/verify/:token',
  recover: '/recover/:token',
  forgotAccess: '/forgot-access',
  qrAuth: '/qr-auth/:sessionToken',
} as const
